module.exports = __webpack_public_path__ + "img/selected6-min.76cfe716.png";